import React from 'react';
import { breakpoints, color, font } from '../../styles/theme';
import { CmsDestination } from '../../integrations/contentful/types';
import Container from '../grid/Container';
import DestinationCard from '../destinations/DestinationCard';
import { t } from '../../utils/i18n';
import Button from '../elements/Button';
import ButtonText from '../elements/ButtonText';
import { Paths } from '../../urls/Paths';

interface CoursesGridProps {
  destinations: CmsDestination[];
}

const CoursesGrid: React.FC<CoursesGridProps> = ({ destinations = [] }) => {
  const displayDestinations = destinations.slice(0, 6);

  return (
    <div className="courses-section" id="kentat-section">
      <Container>
        <div className="section-header">
          <p className="section-label">{t('Upeat pelikentät')}</p>
          <h2 className="section-title">{t('Kentät')}</h2>
          <p className="section-subtitle">
            {t('Tutustu Viron upeimpiin golfkenttiin')}
          </p>
        </div>
        <div className="courses-grid">
          {displayDestinations.map((destination, index) => (
            <div key={`course-${index}`} className="course-card-wrapper">
              <DestinationCard
                country={destination.fields.country}
                mainImage={destination.fields.mainImage}
                name={destination.fields.title}
                slug={destination.fields.slug}
              />
            </div>
          ))}
        </div>
        <div className="cta-container">
          <Button onClick={() => (window.location.href = Paths.Destinations)}>
            <ButtonText variant="primary" color="white">
              {t('Katso kaikki kentät')}
            </ButtonText>
          </Button>
        </div>
      </Container>
      {/*language=CSS*/}
      <style jsx>{`
        .courses-section {
          padding: 80px 0 100px;
          background: linear-gradient(135deg, #f8f7ff 0%, #eee9ff 100%);
        }

        .section-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .section-label {
          font-family: ${font.primary};
          font-size: 0.8rem;
          font-weight: 600;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: ${color.brand};
          margin: 0 0 8px;
        }

        .section-title {
          font-family: ${font.primary};
          font-size: 2.5rem;
          font-weight: 700;
          color: ${color.dark};
          margin: 0 0 12px;
        }

        .section-subtitle {
          font-family: ${font.primary};
          font-size: 1.1rem;
          color: ${color.gray};
          margin: 0;
          line-height: 1.5;
        }

        .courses-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 32px;
        }

        .course-card-wrapper {
          border-radius: 16px;
          overflow: hidden;
          transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .course-card-wrapper:hover {
          transform: scale(1.03);
          box-shadow: 0 12px 40px rgba(66, 48, 99, 0.15);
        }

        .course-card-wrapper :global(img) {
          transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .course-card-wrapper:hover :global(img) {
          transform: scale(1.08);
          opacity: 1 !important;
        }

        .cta-container {
          display: flex;
          justify-content: center;
          margin-top: 48px;
        }

        @media ${breakpoints.medium} {
          .courses-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media ${breakpoints.large} {
          .courses-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
      `}</style>
    </div>
  );
};

export default CoursesGrid;
